import { axiosInstance } from 'src/services/axiosInstance'
import { SEARCH_USER } from '../constants'

export const getUserByRole = async (user: { role: string; text: string }) => {
	const query = `${user.text ? `?autocomplete=${user.text.toLowerCase()}` : ''}`
	const { data } = await axiosInstance.get(`${SEARCH_USER}${query}`)
	return data
}
